import { Component, Input } from '@angular/core';

import { PaymentOrPromoComponent } from '../../payment-or-promo.component';

/**
 * "the_portrait" view of /payment-or-promo.
 *
 * The one screen where the header's "EST 2026" label is interactive: it replaces the default
 * theme's star-icon button as the staff PIN trigger. The #content template it opens stays in
 * the page's own markup, so the page's @ViewChild keeps resolving.
 */
@Component({
  selector: 'app-payment-or-promo-portrait',
  templateUrl: './payment-or-promo-portrait.component.html',
  styleUrls: ['./payment-or-promo-portrait.component.scss']
})
export class PaymentOrPromoPortraitComponent {

  @Input() host!: PaymentOrPromoComponent;

}
